var map = {
	"./highres/ialtos/AgataSkibinska.jpg": 491,
	"./highres/ialtos/AgnieszkaBereza.jpg": 9447,
	"./highres/ialtos/AleksandraMroczko.jpg": 5514,
	"./highres/ialtos/DagmaraGrenik.jpg": 9975,
	"./highres/ialtos/EwaLukasikKrol.jpg": 3782,
	"./highres/ialtos/EwaSkorska.jpg": 7523,
	"./highres/ialtos/KatarzynaSzeloch.jpg": 3860,
	"./highres/ialtos/MartaLaburda.jpg": 9726,
	"./highres/ialtos/MartaLemieszewska.jpg": 4859,
	"./highres/iialtos/AdrianaIkoniak.jpg": 7198,
	"./highres/iialtos/AleksaMucha.jpg": 6456,
	"./highres/iialtos/AnnaZarkadas.jpg": 4586,
	"./highres/iialtos/DariaPisula.jpg": 5166,
	"./highres/iialtos/HannaKonieczna.jpg": 50,
	"./highres/iialtos/IzabelaGrad.jpg": 751,
	"./highres/iialtos/JoannaPolanska.jpg": 1402,
	"./highres/iialtos/KatarzynaGemborys.jpg": 6796,
	"./highres/iialtos/KatarzynaRadon.jpg": 4411,
	"./highres/iisopranos/AlicjaTrela.jpg": 3052,
	"./highres/iisopranos/AnnaBudekKorczagin.jpg": 3228,
	"./highres/iisopranos/AnnaSeidelMydlowska.jpg": 8725,
	"./highres/iisopranos/JoannaKobylinska.jpg": 6634,
	"./highres/iisopranos/MartynaPieniazek.jpg": 37,
	"./highres/iisopranos/PaulaSobok.jpg": 7510,
	"./highres/iisopranos/PaulinaLopatka.jpg": 4699,
	"./highres/iisopranos/SylwiaWrzeszcz.jpg": 9319,
	"./highres/isopranos/AgataLuboinska.jpg": 8935,
	"./highres/isopranos/AleksandraWozniak.jpg": 2738,
	"./highres/isopranos/AnnaAleksandrowicz.jpg": 3784,
	"./highres/isopranos/AnnaBialek.jpg": 363,
	"./highres/isopranos/AnnaMarcinek.jpg": 6239,
	"./highres/isopranos/DominikaUrban.jpg": 124,
	"./highres/isopranos/KamilaMadej.jpg": 646,
	"./highres/isopranos/NataliaMutor.jpg": 7658,
	"./highres/isopranos/OlenaDziurdz.jpg": 2977
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3082;